import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'components/common/modal';

import { closeModal } from 'features/modalSlice';

import './AmenitiesModal.css';

const AmenitiesModal = ({ width = 500 }) => {
    const dispatch = useDispatch();

    const { isAmenitiesModalOpen } = useSelector((state) => state.modal);

    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);

    const modalTitle = Lang?.amenities;
    const handleModalClose = () => {
        dispatch(closeModal({ modalId: 'AmenitiesModal' }));
    };
    const amenitiesData = useSelector((state) =>
        Object.values(state.user?.amenitiesData || {})
    );
    const renderContent = () => {
        return (
            <div className="amenities-body">
                <div className="ab-amenities-text">
                    <div className="amenities-message">
                        <div className="ab-section-body ab-amenities-wrapper">
                            {amenitiesData.map((amenity, index) => (
                                <div className="ab-amenities-row" key={index}>
                                    <label className="ab-amenities-checkmark-container">
                                        {amenity}
                                        <span className="ab-checkmark"></span>
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <Modal
            className="ab-modal--amenities"
            isOpen={isAmenitiesModalOpen}
            onClose={handleModalClose}
            onOverlayClick={handleModalClose}
            placement="center"
            renderContent={renderContent}
            title={modalTitle}
            width={width}
        />
    );
};
AmenitiesModal.propTypes = {
    width: PropTypes.number,
};

export default AmenitiesModal;
